module.exports = __webpack_public_path__ + "ff55a0257b33c857e052f29d0b8f3259.svg";